import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

export const featureAuth = (state: RootState) => state.auth;
export const featureCodebooks = (state: RootState) => state.codebooks;
const featureUserLabels = (state: RootState) => state.userLabels;
const featureBilling = (state: RootState) => state.billing;
const featureContentViewer = (state: RootState) => state.contentViewer;
const featureCompetence = (state: RootState) => state.competence;
const featureWorkplaces = (state: RootState) => state.workplaces;

export const selectAuthIsLogged = createSelector([featureAuth], (auth) => !!auth.user);
export const selectAuthUser = createSelector([featureAuth], (auth) => auth.user);
export const selectCodebooks = createSelector([featureCodebooks], (state) => state);
export const selectUserLabels = createSelector([featureUserLabels], (state) => state);
export const selectContentViewer = createSelector([featureContentViewer], (state) => state);
export const selectCompetences = createSelector([featureCompetence], (state) => state);
export const selectWorkplaces = createSelector([featureWorkplaces], (state) => state);

export const selectBilling = createSelector([featureBilling], (state) => state);
